<template>
  <v-text-field
    v-bind:value="valueUpperCased"
    v-on:input="colorUpdated"
    v-mask="mask"
    :rules="[rules.required, rules.counter]"
    v-bind="$props"
  >
    <template v-slot:append>
      <v-menu
        v-model="colorPickerOpen"
        top
        nudge-bottom="103"
        nudge-left="21"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on }">
          <div :style="swatchStyle" v-on="on" />
        </template>
        <v-card>
          <v-card-text class="pa-0">
            <v-color-picker
              v-bind:value="valueUpperCased"
              v-on:update:color="colorPickerChange"
              mode="hexa"
            />
          </v-card-text>
        </v-card>
      </v-menu>
    </template>
  </v-text-field>
</template>

<script>
import textColor from '../utils/textColor';

export default {
  name: 'ColorInput',
  props: {
    label: {
      type: String,
    },
    value: {
      type: String,
    },
    solo: Boolean,
  },
  data() {
    return {
      mask: '!#XXXXXX',
      colorPickerOpen: false,
      lastColorPickerValue: null,
      rules: {
        required: (value) => !!value || 'Required.',
        counter: (value) => value.length === 7 || 'Exactly 7 characters',
      },
    };
  },
  computed: {
    valueUpperCased() {
      if (typeof this.value !== 'string') {
        return this.value;
      }

      return this.value.toUpperCase();
    },
    swatchStyle() {
      const size = '20px';
      let borderColor = this.value;

      if (textColor(this.value) === '#000000') {
        borderColor = '#999999';
      }

      return {
        backgroundColor: this.value,
        borderColor: borderColor,
        borderWidth: '1px',
        borderStyle: 'solid',
        cursor: 'pointer',
        height: size,
        width: size,
        borderRadius: '50%',
      };
    },
  },
  watch: {
    colorPickerOpen(value) {
      if (value === false && this.lastColorPickerValue !== null) {
        this.colorUpdated(this.lastColorPickerValue);
      }
    },
  },
  methods: {
    colorUpdated(color) {
      this.$emit('input', color);
      this.$emit('colorUpdated', color);
    },
    colorPickerChange(color) {
      if (!color) {
        this.lastColorPickerValue = this.valueUpperCased;
        return;
      }

      this.lastColorPickerValue = color.hex;
    },
  },
};
</script>
